import React, { createContext, useContext, useState, useEffect } from 'react';
import { UI } from '../config/simulatorConfig';
import en from './en.json';
import nl from './nl.json';

const messages = { en, nl };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Initialize language from URL or default
  const getInitialLang = () => {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang');
    if (urlLang && UI.SUPPORTED_LANGUAGES.includes(urlLang)) {
      return urlLang;
    }
    return UI.DEFAULT_LANGUAGE;
  };

  const [language, setLanguage] = useState(getInitialLang());

  useEffect(() => {
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      const urlLang = params.get('lang');
      if (urlLang && UI.SUPPORTED_LANGUAGES.includes(urlLang)) {
        setLanguage(urlLang);
      }
    };
    window.addEventListener('popstate', handleUrlChange);
    return () => window.removeEventListener('popstate', handleUrlChange);
  }, []);

  // Translation function using context language
  const t = (key, vars = {}) => {
    const keys = key.split('.');
    let text = messages[language];
    for (const k of keys) {
      if (text && text[k] !== undefined) {
        text = text[k];
      } else {
        // console.warn(`Translation key not found: ${key}`);
        return key;
      }
    }
    if (vars && typeof text === 'string') {
      Object.keys(vars).forEach(k => {
        text = text.replace(`{{${k}}}`, vars[k]);
      });
    }
    return text;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguageContext() {
  return useContext(LanguageContext);
} 